"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Button_1 = __importDefault(require("../../common/js/atoms/Button"));
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const ButtonVariant_1 = __importDefault(require("../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const translation_1 = require("../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const LocalStorageKeys_1 = __importDefault(require("../enums/LocalStorageKeys"));
const MassiveCompany_1 = __importDefault(require("../stores/MassiveCompany"));
class PopoverLoggedIn extends react_1.default.Component {
    visible = AuthorizationStore_1.default.user !== null && localStorage.getItem(LocalStorageKeys_1.default.popoverLoggedInClicked) === null;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            visible: mobx_1.observable,
        });
    }
    render() {
        const text = (0, translation_1.translateNoFallback)('modal.authenticated_user_info.text', {
            name: MassiveCompany_1.default.company?.serviceOrganizationMassiveAddress?.name1 ?? '',
            channel: AuthorizationStore_1.default.channelId,
        });
        if (!this.visible || !text) {
            return null;
        }
        return (react_1.default.createElement("div", { className: "znd-user-notice" },
            react_1.default.createElement("div", { className: "znd-user-notice-content container p-3" },
                react_1.default.createElement("div", { className: "znd-user-notice__body row" },
                    react_1.default.createElement("div", { className: "znd-user-notice__message col-11 px-4", dangerouslySetInnerHTML: { __html: text } }),
                    react_1.default.createElement("div", { className: "znd-user-notice__close row col-1 align-items-start", onClick: () => {
                            this.popoverIsClicked();
                        } },
                        react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.close }))),
                react_1.default.createElement("div", { className: "znd-user-notice__actions row" },
                    react_1.default.createElement("div", { className: "col-8 px-4" },
                        react_1.default.createElement(Button_1.default, { className: "znd-user-notice__action-login", variant: ButtonVariant_1.default.primary, text: (0, translation_1.t)('modal.authenticated_user_info.action'), onClick: () => {
                                this.popoverIsClicked();
                            } })))),
            react_1.default.createElement("div", { className: "znd-user-notice-triangle" })));
    }
    popoverIsClicked() {
        localStorage.setItem(LocalStorageKeys_1.default.popoverLoggedInClicked, 'true');
        this.visible = false;
    }
}
exports.default = (0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(PopoverLoggedIn));
